import BlueOnionColorCss from "./BLueOnion/color.module.css";
import DefaultColorCss from "./Default/color.module.css";
import { BlueOnionActiveTab, BlueOnionActiveText, BlueOnionAssetTab, BlueOnionColors, BlueOnionInActiveText, BlueOnionInvertDark, BlueOnionLabel, BlueOnionModalBg, BlueOnionTextField, BlueOnionTextFieldPlaceHolder } from "./BLueOnion/color.config";
import { DefaultActiveTab, DefaultActiveText, DefaultAssetTab, DefaultColors, DefaultInActiveText, DefaultInvertDark, DefaultLabel, DefaultModalBg, DefaultTextField, DefaultTextFieldPlaceHolder } from "./Default/color.config";
import { Cookies } from "react-cookie";

const colorTheme = () => {
    const cookies = new Cookies();
    const isBlueOnion = cookies.get("isBlueOnion");
   
    if (isBlueOnion === "true") {
        return BlueOnionColors;
    } else {
        return DefaultColors;
    }
};

const invertDarkTheme = () => {
    const cookies = new Cookies();
    const isBlueOnion = cookies.get("isBlueOnion");

    if (isBlueOnion === "true") {
        return BlueOnionInvertDark;
    } else {
        return DefaultInvertDark;
    }
};

const colorTheme_Label = () => {
    const cookies = new Cookies();
    const isBlueOnion = cookies.get("isBlueOnion");

    if(isBlueOnion === "true"){
        return BlueOnionLabel;
    }else{
        return DefaultLabel;
    }
}

const assetTab_Theme = () => {
    const cookies = new Cookies();
    const isBlueOnion = cookies.get("isBlueOnion");

    if(isBlueOnion === "true"){
        return BlueOnionAssetTab;
    }else{
        return DefaultAssetTab;
    }
}

const colorTheme_TextField = () => {
    const cookies = new Cookies();
    const isBlueOnion = cookies.get("isBlueOnion");

    if(isBlueOnion === "true"){
        return BlueOnionTextFieldPlaceHolder;
    }else{
        return DefaultTextFieldPlaceHolder;
    }
}

const invertTextFiled = () => {
    const cookies = new Cookies();
    const isBlueOnion = cookies.get("isBlueOnion");
    if (isBlueOnion === "true") {
        return BlueOnionTextField;
    } else {
        return DefaultTextField;
    }

}

const invertActiveText = () => {
    const cookies = new Cookies();
    const isBlueOnion = cookies.get("isBlueOnion");
    if (isBlueOnion === "true") {
        return BlueOnionActiveText;
    } else {
        return DefaultActiveText;
    }
}

const invertInActiveText = () => {
    const cookies = new Cookies();
    const isBlueOnion = cookies.get("isBlueOnion");
    if (isBlueOnion === "true") {
        return BlueOnionInActiveText;
    } else {
        return DefaultInActiveText;
    }
}

const backgroundTheme = () => {
    const cookies = new Cookies();
    const isBlueOnion = cookies.get("isBlueOnion");
    if (isBlueOnion === true) {
        return BlueOnionColorCss;
    } else {
        return DefaultColorCss;
    }
};

const colorTheme_CategoryTab = () => {
    const cookies = new Cookies();
    const isBlueOnion = cookies.get("isBlueOnion");
    if (isBlueOnion === "true") {
        return BlueOnionActiveTab;
    } else {
        return DefaultActiveTab;
    }
};

const colorTheme_ModalSubBg = () => {
    const cookies = new Cookies();
    const isBlueOnion = cookies.get("isBlueOnion");
    if (isBlueOnion === "true") {
        return BlueOnionModalBg;
    } else {
        return DefaultModalBg;
    }
};

export { colorTheme, backgroundTheme, invertDarkTheme, invertTextFiled, invertActiveText, colorTheme_Label, colorTheme_TextField, colorTheme_CategoryTab, assetTab_Theme, colorTheme_ModalSubBg  };